import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Country } from '@mp/organization-master-data/countries/domain';

export const CountriesActions = createActionGroup({
  source: 'Organization Master Data - Countries',
  events: {
    fetchCountries: emptyProps(),
    fetchCountriesSuccess: props<{ countries: Country[] }>(),
    fetchCountriesError: emptyProps(),
  },
});
